<template>
    <div :class="['snackbar', type]" @touchstart.passive="handleTouchStart" @touchend.passive="handleTouchEnd">
        <div class="snackbar__top">
            <SvgIcon v-if="icon" :name="icon" class="snackbar__icon" />
            <div class="snackbar__message">{{ message }}</div>
        </div>
        <div v-if="button" class="snackbar__buttons-wrapper">
            <Button v-if="button" @click="button.onClick" type="tertiary" class="snackbar__button">
                {{ button.label }}
            </Button>
            <button v-if="false" @click="closeSnackbar" class="close-button">
                <SvgIcon name="close" />
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import Button from "@/shared/components/atoms/Button.vue";

import { Snackbar } from "@/shared/model/snackbar";

import useSazkaSnackbar from "@/shared/composables/use-sazka-snackbar";
import { onMounted } from "vue";

const props = defineProps<Snackbar>();

const { removeSnackbar } = useSazkaSnackbar();

const swipeThreshold = 20;

let startY = 0;

const handleTouchStart = (event: TouchEvent) => {
    startY = event.touches[0].clientY;
};

const handleTouchEnd = (event: TouchEvent) => {
    const diffY = event.changedTouches[0].clientY - startY;

    if (Math.abs(diffY) > swipeThreshold && diffY > 0) {
        closeSnackbar();
    }
};

onMounted(() => {
    setTimeout(() => {
        removeSnackbar(props);
    }, props.duration ?? 3000);
});

const closeSnackbar = () => {
    if (props.onClose) props.onClose();

    removeSnackbar(props);
};
</script>
